import { bl_ppl_from_peppol_doc_hdr_queue_RowClass } from '../../../dbschema/bl_ppl_from_peppol_doc_hdr_queue.model';
import { BaseContainerModel } from '../../base-container.model';

export class PeppolFromPeppolDocHdrQueueContainerModel extends BaseContainerModel {
    bl_ppl_from_peppol_doc_hdr_queue: bl_ppl_from_peppol_doc_hdr_queue_RowClass = new bl_ppl_from_peppol_doc_hdr_queue_RowClass();
}